import { render } from "./SurveyQuestionView.vue?vue&type=template&id=38593bef"
import script from "./SurveyQuestionView.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__